<template>
    <div class="form-group">
        <label for="date_range_picker">Date Range</label>
        <input v-model="dateRange" type="text" class="form-control" id="date_range_picker" />
    </div>
</template>

<script>
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap-daterangepicker/daterangepicker.js';
import moment from 'moment';
import $ from 'jquery';

export default {
    data() {
        return {
            start_date: this.initial_start_date,
            end_date: this.initial_end_date,
            dateRange: `${this.start_date} - ${this.end_date}`,
        };
    },
    props: {
        initial_start_date: {
            type: String,
            default: moment().subtract(89, 'days').format('YYYY-MM-DD'),
        },
        initial_end_date: {
            type: String,
            default: moment().format('YYYY-MM-DD'),
        },
        minimum_date: {
            type: String,
            default: "2021-01-01"
        },
    },
    mounted() {
        this.initializeDateRangePicker();
    },
    methods: {
        initializeDateRangePicker() {
            const dateRangeInput = document.getElementById('date_range_picker');
            const options = {
                autoUpdateInput: true,
                drops: 'auto',
                startDate: moment(this.start_date),
                endDate: moment(this.end_date),
                ranges: {
                    Today: [moment(), moment()],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'Last 90 Days': [moment().subtract(89, 'days'), moment()],
                    'Last 180 Days': [moment().subtract(179, 'days'), moment()],
                    'Last 365 Days': [moment().subtract(364, 'days'), moment()],
                    'Last 10 Years': [moment().subtract(10, 'year'), moment()],
                    'Whole Period': [moment(this.minimum_date), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [
                        moment().subtract(1, 'month').startOf('month'),
                        moment().subtract(1, 'month').endOf('month'),
                    ],
                    'This Year': [moment().startOf('year'), moment().endOf('year')],
                    'Last Year': [
                        moment().subtract(1, 'year').startOf('year'),
                        moment().subtract(1, 'year').endOf('year'),
                    ],
                },
                locale: {
                    format: 'YYYY-MM-DD',
                    applyLabel: 'Apply',
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom Range',
                },
            };

            $(dateRangeInput).daterangepicker(options, (start, end) => {
                this.dateRange = `${start.format('YYYY-MM-DD')} - ${end.format('YYYY-MM-DD')}`;
                this.$emit('date-changed', {
                    start_date: start.format('YYYY-MM-DD'),
                    end_date: end.format('YYYY-MM-DD'),
                });
            });

            $(dateRangeInput).on('apply.daterangepicker', (event, picker) => {
                const start = picker.startDate.format('YYYY-MM-DD');
                const end = picker.endDate.format('YYYY-MM-DD');
                this.dateRange = `${start} - ${end}`;
            });

            this.$watch('start_date', (newValue) => {
                $(dateRangeInput).data('daterangepicker').setStartDate(newValue);
            });

            this.$watch('end_date', (newValue) => {
                $(dateRangeInput).data('daterangepicker').setEndDate(newValue);
            });
        },
    },
};
</script>

<style scoped>
#date_range_picker {
  border: 2px solid #007bff;
  border-radius: 5px;
  padding: 10px;
  font-size: 1.25rem; /* 20px */
}

#date_range_picker:focus {
  border-color: #0056b3;
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}
</style>